import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal, Pagination } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  getGenderText,
  getStatusColor,
  getStatusText,
} from "../../Common/Utils/statusUtils";
import search from "../../assets/images/search-lg.svg";
import {
  getTermsandcondition,
  deleteTermsandcondition,
} from "../../../redux/termsandcondition/action";
import Filter from "../../Common/Filter/Filter";
import ModalDelete from "../../Common/Popup/ModalDelete";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import NormalCardHeader from "../../Common/CardHeader/NormalCardHeader";
import "../../Common/Styles/Listing.css";
import HeaderwithOnlySearch from "../../Common/CardHeader/HeaderwithOnlySearch";

const TermsConditionList = () => {
  const [params, setParams] = useState({
    page: 1,
  });
  const { t } = useTranslation();
  const [openFilter, setOpenFilter] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const [loading, setLoading] = useState(false);
  const [componentList, setComponentList] = useState([]);
  console.log(componentList, "componentListcomponentList");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const termsandcondition = useSelector(
    ({ termsandcondition: { termsandconditionlist } }) => termsandconditionlist
  );

  useEffect(() => {
    if (termsandcondition) {
      setComponentList(termsandcondition.terms_and_conditions || []);
    }
  }, [termsandcondition]);

  useEffect(() => {
    dispatch(getTermsandcondition());
  }, [dispatch]);

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteTermsandcondition(currentComponent.id, setLoading));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  const addComponent = () => {
    navigate("/termscondition/add");
  };

  const updateComponent = (id) => {
    navigate(`/termscondition/update/${id}`);
  };

  const typeOptions = {
    1: "User T/C",
    2: "Business T/C",
    3: "Driver T/C",
    4: "Cancellation T/C",
    5: "Rescheduling T/C",
  };

  return (
    <div className="card-head">
      <div
        onClick={() => setOpenFilter(false)}
        className={openFilter ? `overlay show` : "overlay"}
      ></div>
      <Filter
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        params={params}
        setParams={setParams}
      />
      <CardBody className="table-sec">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Type</th>
              <th scope="col">Description</th>
              <th scope="col">Ar Description</th>
              <th scope="col" className="text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {componentList.length > 0 ? (
              componentList.map((item, index) => (
                <tr key={index}>
                  <td> {index + 1 + (params?.page - 1) * 10}</td>

                  <td>{typeOptions[item?.type] || "Unknown Type"}</td>
                  <td>
                    {item?.description.length > 200
                      ? item.description.slice(0, 200) + "..."
                      : item.description}
                  </td>
                  <td>
                    {item?.ar_description.length > 200
                      ? item.ar_description.slice(0, 200) + "..."
                      : item.ar_description}
                  </td>
                  <td>
                    <div
                      className="d-flex align-items-center"
                      style={{ columnGap: "10px" }}
                    >
                      <button
                        className="border-button"
                        onClick={() => updateComponent(item.id)}
                      >
                        <span>Update</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No t&c found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <CommonPagination
          params={params}
          setParams={setParams}
          pagination_meta={termsandcondition?.pagination_meta}
        />
      </CardBody>
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <ModalDelete
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        />
      </Modal>
    </div>
  );
};

export default TermsConditionList;
